var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 1,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.208 19.194c0-.606-.054-1.19-.155-1.749H19v3.308h4.602a3.933 3.933 0 0 1-1.707 2.58v2.145h2.764c1.616-1.488 2.549-3.68 2.549-6.284Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 27.55c2.309 0 4.244-.766 5.659-2.072l-2.763-2.145c-.766.513-1.745.816-2.896.816-2.227 0-4.112-1.504-4.784-3.525H11.36v2.215A8.547 8.547 0 0 0 19 27.55Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.216 20.624A5.14 5.14 0 0 1 13.948 19c0-.564.097-1.112.268-1.625V15.16H11.36a8.546 8.546 0 0 0-.91 3.84c0 1.38.33 2.685.91 3.84l2.856-2.216Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 13.85c1.256 0 2.383.431 3.269 1.278l2.452-2.452c-1.48-1.38-3.416-2.227-5.72-2.227a8.547 8.547 0 0 0-7.641 4.71l2.856 2.216c.672-2.021 2.557-3.525 4.784-3.525Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogle;